export const getTabPaneClassName = (activeTab, tabId, extraClasses = "") =>
  ["tab-pane", "fade", "pt-3", extraClasses, activeTab === tabId ? "show active" : ""]
    .filter(Boolean)
    .join(" ")
    .trim();
